import {call, put, takeEvery} from 'redux-saga/effects';
import {fetchAvailabilitiesDmsFailure, fetchAvailabilitiesDmsSuccess, fetchAvailabilitiesFailure, fetchAvailabilitiesSuccess} from '../actions/availabilitiesActions';
import {FETCH_AVAILABILITIES, FETCH_AVAILABILITIES_DMS} from '../constants/ActionTypes';
import AvailabilitiesService from '../services/api/AvailabilitiesService';

function* fetchAvailabilities({payload}) {
  const {id, payload: body} = payload;
  try {
    const availabilities = yield call(AvailabilitiesService.getAvailabilities, id, body);
    yield put(fetchAvailabilitiesSuccess(availabilities.body));
  } catch (error) {
    yield put(fetchAvailabilitiesFailure(error));
  }
}

function* fetchAvailabilitiesDms({payload}) {
  const {id, payload: body} = payload;
  try {
    const availabilities = yield call(AvailabilitiesService.getAvailabilitiesDms, id, body);
    yield put(fetchAvailabilitiesDmsSuccess(availabilities.body));
  } catch (error) {
    yield put(fetchAvailabilitiesDmsFailure(error));
  }
}

export function* watchFetchAvailabilities() {
  yield takeEvery(FETCH_AVAILABILITIES, fetchAvailabilities);
  yield takeEvery(FETCH_AVAILABILITIES_DMS, fetchAvailabilitiesDms);
}
